import {
  GET_CLUB,
  ADD_CLUB,
  UPDATE_CLUB,
  DELETE_CLUB,
  ERROR_XHR
} from '../mutation-types'

import toastr from 'toastr'

const state = {
  all: []
}

const mutations = {
  [GET_CLUB] (state, clubs) {
    state.all = clubs
  },
  [ADD_CLUB] (state, project) {
    state.all.push(project)
    toastr.success('Le CLUB a été créé')
  },
  [UPDATE_CLUB] (state, oldProject, updatedProject) {
    state.all.$remove(oldProject)
    state.all.push(updatedProject)
    toastr.success('Le CLUB a été modifié')
  },
  [DELETE_CLUB] (state, project) {
    state.all.$remove(project)
    toastr.success('Le CLUB a été supprimé')
  },
  [ERROR_XHR] (state, error) {
    console.log(state)
    console.log(error)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/clubs.js